import React from 'react';
import _ from 'lodash';

import EditAccount from '../AccountComponents/EditAccount';

import Style from '../SharedStyles/SharedStyles.module.scss';

const LENGTH_ERROR = 'LENGTH_ERROR';
const FORMAT_ERROR = 'FORMAT_ERROR';

export function setEditAccountErrors(cb) {
  const { editFirstName, editLastName } = this.state;
  const processedFirstName = _.trim(editFirstName);
  const processedLastName = _.trim(editLastName);
  const pattern = /^[a-z]*$/i;

  let firstNameError;
  let lastNameError;

  if (processedFirstName.length < 2) firstNameError = LENGTH_ERROR;
  if (processedLastName.length < 2) lastNameError = LENGTH_ERROR;
  if (!pattern.test(processedFirstName)) firstNameError = FORMAT_ERROR;
  if (!pattern.test(processedLastName)) lastNameError = FORMAT_ERROR;

  const setStateCallBack = () => {
    const { firstNameError, lastNameError } = this.state;
    const hasErrors = firstNameError || lastNameError;
    if (cb) return cb(hasErrors, processedFirstName, processedLastName);
    return hasErrors;
  };

  return this.setState({ firstNameError, lastNameError }, setStateCallBack);
}

function onEditAccount() {
  const { editAccount, editAccountCb } = this.props;
  const handleSuccess = ({ data }) => {
    editAccountCb(data);
    this.toggleEditAccount();
    this.toggleAccountMain(true);
  };
  this.setEditAccountErrors((hasErrors, processedFirstName, processedLastName) => {
    if (!hasErrors && editAccount) {
      editAccount(
        {
          firstName: processedFirstName,
          lastName: processedLastName,
        },
        result => {
          const { error, success, data } = result;
          if (error) return this.setState({ editGenericError: error.message });
          if (success) return handleSuccess({ data });
          return null;
        },
      );
    }
  });
}

function onEditDeleteClick() {
  this.toggleEditAccount();
  this.toggleDeleteAccount();
}

export function onEditAccountBackClick() {
  this.toggleEditAccount();
  this.toggleAccountMain();
}

export function renderEditAccount() {
  const {
    backgroundClass,
    isMobile,
    language: { profileEdit_header: headerText },
    language,
  } = this.props;
  const {
    editEmail,
    editFirstName,
    editGenericError,
    editLastName,
    firstNameError,
    lastNameError,
    showEditAccount,
  } = this.state;
  const editAccountBackClick = onEditAccountBackClick.bind(this);
  const editAccount = onEditAccount.bind(this);
  const EditDeleteClick = onEditDeleteClick.bind(this);
  const headerProps = {
    headerText,
    iconMobile: <button onClick={() => editAccountBackClick()} className={Style.back} />,
    isDesktop: !isMobile,
    onClose: opts => this.onClose(opts),
    renderLogo: this.renderLogo,
    showHeaderDesktop: true,
  };

  const editAccountProps = {
    backgroundClass,
    editEmail,
    editFirstName,
    editGenericError,
    editLastName,
    firstNameError,
    headerProps,
    language,
    lastNameError,
    onEditAccount: editAccount,
    onEditAccountBackClick: editAccountBackClick,
    onEditDeleteClick: EditDeleteClick,
    onFieldChange: this.onFieldChange,
    showEditAccount,
  };

  if (!showEditAccount) return null;
  return <EditAccount {...editAccountProps} />;
}
